// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_wrapper__YEErg {
  max-width: 721px;
}

.styles_heading__H9DLy {
  font-size: 36px;
  font-family: "Poppins", sans-serif;
  font-weight: 700;
  letter-spacing: 0.0041em;
  text-align: center;
  color: #313333;
  line-height: 50px;
}

.styles_subheading__WGUON {
  font-size: 16px;
  font-family: "Inter", sans-serif;
  font-weight: 400;
  color: #BABABA;
  text-align: center;
}

.styles_codeField__jA\\+aX {
  width: 52px !important;
  height: 56px !important;
  padding: 12px 14px;
  border: 1px solid #BABABA;
  border-radius: 7px;
  color: #313333;
  font-family: "Inter", sans-serif;
  font-weight: 700;
  font-size: 28px;
}
.styles_codeFieldHighlighted__oa5rh {
  border: 1px solid #D23535;
  box-shadow: 0 0 0 3px rgba(239, 47, 50, 0.2);
}

.styles_checking__TXzDp {
  font-family: "Inter", sans-serif;
  font-weight: 400;
  font-size: 14px;
  color: #616A85;
}

.styles_resendAction__7XFDy {
  color: #29B473;
  font-family: "Inter", sans-serif;
  font-weight: 600;
  font-size: 14px;
}

@media screen and (max-width: 1440px) {
  .styles_wrapper__YEErg {
    max-width: 521px;
  }
}
@media screen and (max-width: 568px) {
  .styles_heading__H9DLy {
    font-size: 22px;
  }
  .styles_subheading__WGUON {
    font-size: 14px;
  }
  .styles_codeField__jA\\+aX {
    width: 46px !important;
  }
}`, "",{"version":3,"sources":["webpack://./src/pages/Verification/styles.module.scss","webpack://./src/constants/fonts.scss","webpack://./src/constants/colors.scss"],"names":[],"mappings":"AAGA;EACE,gBAAA;AADF;;AAIA;EACE,eAAA;EACA,kCCPQ;EDQR,gBAAA;EACA,wBAAA;EACA,kBAAA;EAEA,cEbM;EFcN,iBAAA;AAFF;;AAKA;EACE,eAAA;EACA,gCChBM;EDiBN,gBAAA;EACA,cAAA;EACA,kBAAA;AAFF;;AAKA;EACE,sBAAA;EACA,uBAAA;EACA,kBAAA;EACA,yBAAA;EACA,kBAAA;EAEA,cEhCM;EFiCN,gCC9BM;ED+BN,gBAAA;EACA,eAAA;AAHF;AAKE;EACE,yBAAA;EACA,4CAAA;AAHJ;;AAOA;EACE,gCCzCM;ED0CN,gBAAA;EACA,eAAA;EACA,cAAA;AAJF;;AAOA;EACE,cEjDM;EFkDN,gCCjDM;EDkDN,gBAAA;EACA,eAAA;AAJF;;AAOA;EACE;IACE,gBAAA;EAJF;AACF;AAOA;EACE;IACE,eAAA;EALF;EAQA;IACE,eAAA;EANF;EAUA;IACE,sBAAA;EARF;AACF","sourcesContent":["@import 'constants/fonts.scss';\n@import 'constants/colors.scss';\n\n.wrapper {\n  max-width: 721px;\n}\n\n.heading {\n  font-size: 36px;\n  font-family: $poppins;\n  font-weight: 700;\n  letter-spacing: 0.0041em;\n  text-align: center;\n\n  color: $black;\n  line-height: 50px;\n}\n\n.subheading {\n  font-size: 16px;\n  font-family: $inter;\n  font-weight: 400;\n  color: #BABABA;\n  text-align: center;\n}\n\n.codeField {\n  width: 52px !important;\n  height: 56px !important;\n  padding: 12px 14px;\n  border: 1px solid #BABABA;\n  border-radius: 7px;\n\n  color: $black;\n  font-family: $inter;\n  font-weight: 700;\n  font-size: 28px;\n\n  &Highlighted {\n    border: 1px solid #D23535;\n    box-shadow: 0 0 0 3px rgba(239, 47, 50, 0.2);\n  }\n}\n\n.checking {\n  font-family: $inter;\n  font-weight: 400;\n  font-size: 14px;\n  color: #616A85;\n}\n\n.resendAction {\n  color: $green;\n  font-family: $inter;\n  font-weight: 600;\n  font-size: 14px;\n}\n\n@media screen and (max-width: 1440px) {\n  .wrapper {\n    max-width: 521px;\n  }\n}\n\n@media screen and (max-width: 568px) {\n  .heading {\n    font-size: 22px;\n  }\n\n  .subheading {\n    font-size: 14px;\n  }\n\n\n  .codeField {\n    width: 46px!important;\n  }\n}\n","@import url('https://fonts.googleapis.com/css2?family=Inter:wght@300;400;500;600&family=Poppins:wght@400;500;600;700&family=Roboto&display=swap');\n\n$poppins: 'Poppins', sans-serif;\n$roboto: 'Roboto', sans-serif;\n$inter: 'Inter', sans-serif;\n","$gray: #6C7275;\n$black: #313333;\n$blue: #0084FF;\n$green: #29B473;\n$white: #FEFEFE;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"wrapper": `styles_wrapper__YEErg`,
	"heading": `styles_heading__H9DLy`,
	"subheading": `styles_subheading__WGUON`,
	"codeField": `styles_codeField__jA+aX`,
	"codeFieldHighlighted": `styles_codeFieldHighlighted__oa5rh`,
	"checking": `styles_checking__TXzDp`,
	"resendAction": `styles_resendAction__7XFDy`
};
export default ___CSS_LOADER_EXPORT___;
